export default __webpack_public_path__ + "static/media/bidayuh12.411c7bf8.png";